import React from 'react'

import { InfoCardPartProps } from './info-card.d';

import InfoCard from '/react4xp/components/InfoCard'

function InfoCardPart(props: InfoCardPartProps) {
    return <InfoCard {...props} />
}

export default (props) => <InfoCardPart {...props} />
